<template>
  <div class="home">
    <img src="@/assets/image/Slice 28@3x.png" alt="" class="home-bg">
    <header-component />
    <nav>
      <div class="nav-txt"  data-aos="fade-up">Bravotree</div>
      <div class="nav-txt"  data-aos="fade-up" data-aos-delay="100">{{ $t('home.nav.discuss') }}</div>
      <div class="nav-txt"  data-aos="fade-up" data-aos-delay="200">{{ $t('home.nav.infinite') }}</div>
      <div class="btn" data-aos-offset="100" data-aos-delay="300"  data-aos="fade-up" @click="$refs.connectRef.toConnectIndex()">{{ $t('home.nav.experience') }}</div>
    </nav>
    <div class="banner">
      <div class="banner-nav flex flex-align-center" :style="{ transform: `translateX(${scrollOffset}px)` }">
        <img :src="require(`@/assets/image/banner/Slice 26@2x(${(index % imageCount) + 1}).png`)" alt=""
          class="banner-img" v-for="(item, index) in duplicatedImages" :key="index" @mouseenter="handleMouseEnter(index)"
          @mouseleave="handleMouseLeave(index)"
          :class="{ 'zoomed': hoveredIndex === index }"/>
      </div>
    </div>
    <div class="content1 flex flex-align-center flex-justify-end">
      <div class="l flex flex-column inter">
        <h1  data-aos="fade-right">{{ $t('home.intro.title') }}</h1>
        <p  data-aos="fade-right" data-aos-delay="100">{{ $t('home.intro.desc') }}</p>
      </div>
      <div class="r">
        <img src="@/assets/image/Slice 31@3x.png" alt="" class="content1-img" data-aos="fade" />
        <div class="r-nav">
          <img src="@/assets/image/Slice 31@3x(1).png" alt="" class="content2-img"  data-aos="fade-up-left"/>
          <img src="@/assets/image/Slice 31@3x(2).png" alt="" class="content3-img" data-aos="fade-up"/>
          <img src="@/assets/image/Slice 31@3x(3).png" alt="" class="content4-img" data-aos="fade-down-left"/>
          <img src="@/assets/image/Slice 31@3x(4).png" alt="" class="content5-img" data-aos="fade-up-right"/>
          <img src="@/assets/image/Slice 31@3x(5).png" alt="" class="content6-img" data-aos="fade-down"/>
          <img src="@/assets/image/Slice 31@3x(6).png" alt="" class="content7-img" data-aos="fade-down-right"/>
        </div>
      </div>
    </div>

    <div class="content2" data-aos="fade-up">
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="(item, index) in swiperList" :key="index">
          <div class="lb flex justify-content flex-align-center">
            <img :src="item.pic" />
            <div class="flex-column justify-content">
              <h1>{{ $t(item.title) }}</h1>
              <div class="btn" @click="$refs.connectRef.toConnectIndex()">{{ $t('home.carousel.contact') }}</div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content3 flex flex-align-center">
      <div class="l"  data-aos="fade-up">
        <h1>{{ $t('home.coreBusiness.title') }}</h1>
      </div>
      <div class="r flex flex-column">
        <h2 data-aos="fade-up"  data-aos-delay="100">{{ $t('home.coreBusiness.account.title') }}</h2>
        <p data-aos="fade-up" data-aos-delay="200">{{ $t('home.coreBusiness.account.desc') }}</p>
        <h2 data-aos="fade-up" data-aos-offset="50" data-aos-delay="100">{{ $t('home.coreBusiness.strategy.title') }}</h2>
        <p data-aos="fade-up" data-aos-offset="50" data-aos-delay="200">{{ $t('home.coreBusiness.strategy.desc') }}</p>
        <h2 data-aos="fade-up" data-aos-offset="50" data-aos-delay="100">{{ $t('home.coreBusiness.support.title') }}</h2>
        <p data-aos="fade-up" data-aos-offset="50" data-aos-delay="200">{{ $t('home.coreBusiness.support.desc') }}</p>
      </div>
    </div>
    <div class="content4 flex">
      <h1>{{ $t('home.serviceScope.title') }}</h1>
      <kf-component ref="kfContainer"/>
      <div class="flex flex-column box1">
        <div class="card" data-aos="fade-up">
          <div class="title">{{ $t('home.serviceScope.card1.title') }}</div>
          <ul>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card1.li1') }}</div></li>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card1.li2') }}</div></li>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card1.li3') }}</div></li>
          </ul>
        </div>
        <div class="card" data-aos="fade-up" data-aos-delay="100">
          <div class="title">{{ $t('home.serviceScope.card2.title') }}</div>
          <ul>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card2.li1') }}</div></li>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card2.li2') }}</div></li>
          </ul>
        </div>
        <div class="card" data-aos="fade-up" data-aos-delay="200">
          <div class="title">{{ $t('home.serviceScope.card3.title') }}</div>
          <ul>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card3.li1') }}</div></li>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card3.li2') }}</div></li>
          </ul>
        </div>
      </div>
      <div class="flex flex-column box2">
        <div class="card" data-aos="fade-up" data-aos-delay="300">
          <div class="title">{{ $t('home.serviceScope.card4.title') }}</div>
          <ul>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card4.li1') }}</div></li>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card4.li2') }}</div></li>
          </ul>
        </div>
        <div class="card" data-aos="fade-up"  data-aos-delay="400">
          <div class="title">{{ $t('home.serviceScope.card5.title') }}</div>
          <ul>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card5.li1') }}</div></li>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card5.li2') }}</div></li>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card5.li3') }}</div></li>
          </ul>
        </div>
        <div class="card" data-aos="fade-up" data-aos-delay="500">
          <div class="title">{{ $t('home.serviceScope.card6.title') }}</div>
          <ul>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card6.li1') }}</div></li>
            <li><div class="dot"></div><div class="txt">{{ $t('home.serviceScope.card6.li2') }}</div></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content5">
      <h1>{{ $t('home.whyChoose.title') }}</h1>
      <div class="inner flex flex-column">
        <div class="connect" @click="$refs.connectRef.toConnectIndex()">{{ $t('home.whyChoose.connect') }}</div>
        <h2>{{ $t('home.whyChoose.platform.title') }}</h2>
        <p>{{ $t('home.whyChoose.platform.desc') }}</p>
        <!-- <img src="@/assets/image/Slice 32@3x(2).png"/> -->
      </div>
    </div>
    <div class="content6 flex flex-align-center flex-justify-between">
      <div class="inner">
        <div class="txt1">{{ $t('home.features.custom.title') }}</div>
        <div class="txt2">{{ $t('home.features.custom.subtitle') }}</div>
        <div class="txt3">{{ $t('home.features.custom.desc') }}</div>
      </div>
      <div class="inner">
        <div class="txt1">{{ $t('home.features.precise.title') }}</div>
        <div class="txt2">{{ $t('home.features.precise.subtitle') }}</div>
        <div class="txt3">{{ $t('home.features.precise.desc') }}</div>
      </div>
      <div class="inner">
        <div class="txt1">{{ $t('home.features.worryFree.title') }}</div>
        <div class="txt2">{{ $t('home.features.worryFree.subtitle') }}</div>
        <div class="txt3">{{ $t('home.features.worryFree.desc') }}</div>
      </div>
    </div>
    <connect-component ref="connectRef"></connect-component>
    <footer class="flex flex-column flex-align-center">
      <div class="txt">{{ $t('home.footer.partner') }}</div>
      <div class="flex brand">
        <!-- <img src="@/assets/image/Slice 7@3x.png"/>
        <img src="@/assets/image/Slice 7@3x(1).png"/>
        <img src="@/assets/image/Slice 7@3x(2).png"/>
        <img src="@/assets/image/Slice 7@3x(3).png"/> -->
      </div>
      <img src="@/assets/image/Slice 24@3x.png" class="logo1"/>
      <div class="connect" @click="$refs.connectRef.toConnectIndex()">{{ $t('home.footer.connect') }}</div>
      <div class="bot-txt bot-1">BRAVOTREE TECHNOLOGY LIMITED
      </div>
      <div class="bot-txt bot-1">
        RooM 602 6/F KAI YUE COMMERCIAL BUILDING NO.2C ARGYLE STREET MONGKOK KL
    </div>
      <div class="bot-txt bot-2">bravotree@coinsa.vip</div>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'indexPage',
  data () {
    return {

      scrollOffset: 0, // 滚动的偏移量
      imageWidth: 275, // 每张图片宽度（需与你的图片实际宽度一致）
      speed: 0.6, // 滚动速度（值越大滚动越快）
      imageCount: 12, // 图片总数
      timer: null, // 定时器句柄
      swiperList: [
        { pic: require('@/assets/image/Slice 32@3x(2).png'), title: 'home.carousel.items.0.title' },
        { pic: require('@/assets/image/Slice 32@3x(5).png'), title: 'home.carousel.items.1.title' },
        { pic: require('@/assets/image/Slice 32@3x(6).png'), title: 'home.carousel.items.2.title' },
      ],
      hoveredIndex: null
    };
  },
  computed: {
    duplicatedImages () {
      // 克隆图片两份用于无缝滚动
      return Array(this.imageCount * 2).fill(null);
    },
  },
  mounted () {
    this.startScroll();
  },
  beforeDestroy () {
    // 清除定时器
    this.stopScroll();
  },
  methods: {
    startScroll () {
      // 开始滚动动画
      this.timer = setInterval(() => {
        this.scrollOffset -= this.speed;

        // 当滚动偏移量超出实际长度时复位
        if (this.scrollOffset <= -this.imageWidth * this.imageCount) {
          this.scrollOffset = 0;
        }
      }, 16); // 每帧16ms，约60FPS
    },
    stopScroll () {
      // 停止滚动动画
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleMouseEnter(index) {
      this.stopScroll(); // 暂停动画
      this.hoveredIndex = index; // 记录鼠标悬停的索引
    },
    handleMouseLeave() {
      this.startScroll(); // 继续滚动
      this.hoveredIndex = null; // 取消悬停效果
    }
  }
};
</script>
<style lang="less" scoped>
.home {
  position: relative;
}
.home-bg{
  width:100vw;position:absolute;top:0;left:0;z-index:0;}

nav {
  padding-top: 290px;
  position: relative;
  width: 1200px;
  margin: 0 auto;

  .nav-txt {
    font-weight: bold;
    font-size: 70px;
    color: #FFFFFF;
    line-height: 90px;
    text-align: left;
  }

  .btn {
    width: 196px;
    height: 46px;
    line-height: 46px;
    background: #FFFFFF;
    border-radius: 50px 50px 50px 50px;
    font-weight: bold;
    font-size: 16px;
    color: #6D7EEA;
    text-align: center;
    letter-spacing: 3px;
    margin-top: 35px;
    cursor: pointer;
  }
}

.banner {
  margin-top: 265px;
  overflow-x: clip;
  box-sizing: border-box;
  width: 100vw;

  .banner-nav {
    display: flex;
    width: max-content;
    height: 100%;
    white-space: nowrap;
    will-change: transform;
    /* 提升渲染性能 */
  }

  .banner-img {
    width: 275px;
    /** width: 392px; **/
    /** height: 726px; **/
    margin: 0 16px;
    transition: transform 0.3s ease-in-out;
  }
  .banner-img.zoomed {
    transform: scale(1.05); /* 放大 5% */
  }
}

.content1 {
  height: 1081px;
  .l {
    h1 {
      font-family: Inter;
      font-weight: bold;
      font-size: 60px;
      color: #000000;
      line-height: 90px;
      width: 729px;
      display: block;
      text-align: left;
    }

    p {
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 26px;
      color: #8C898E;
      line-height: 40px;
      margin-top: 44px;
      width: 705px;
      display: block;
      text-align: left;
    }
  }

  .r {
    width: 960px;
    background: url('@/assets/image/Slice 50@2x (1).png') no-repeat center/100% 100%;
    height: 100%;
    position: relative;

    img {
      width: 112px;
      height: 112px;
      position: absolute;
      animation: animate2 3s ease-in-out infinite;  /* 动画使容器旋转 */
    }

    .content1-img {
      top: 425px;
      left: 396px;
      width: 165px;
      height: 165px;
      animation: none;
    }
    .r-nav{
      width: 100%;
      height: 100%;
      position: relative;
    }

    .content2-img {
      top: 344px;
      left: 232px;
    }

    .content3-img {
      width: 80px;
      height: 80px;
      top: 248px;
      left: 427px;
      animation-delay: 1s;
    }

    .content4-img {
      width: 94px;
      height: 94px;
      top: 559px;
      left: 247px;
      animation-delay: 2s;
    }

    .content5-img {
      width: 77px;
      height: 77px;
      top: 341px;
      right: 277px;
      animation-delay: 3s;
    }

    .content6-img {
      width: 77px;
      height: 77px;
      top: 659px;
      right: 390px;
      animation-delay: 4s;
    }

    .content7-img {
      top: 503px;
      right: 206px;
      width: 127px;
      height: 127px;
      animation-delay: 5s;

    }
  }
}

.content2 {
  width: 1165px;
  margin: -100px auto 154px;
  padding: 56px 72px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 10px 10px 10px 10px;
  ::v-deep .el-carousel__container{
    height: 336px;
  }
  .lb {
    img {
      width: 515px;
      margin-right: 96px;
    }

    h1 {
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 40px;
      color: #050921;
      line-height: 60px;
      text-align: center;
      display: block;
      width: 480px;
    }

    .btn {
      margin: 40px auto 0;
      width: 180px;
      height: 38px;
      line-height: 38px;
      background: linear-gradient(90deg, #E69AFF 2%, #C597FF 39%, #7280DB 100%);
      border-radius: 60px 60px 60px 60px;
      text-align: center;
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 16px;
      color: #FFFFFF;
    }
  }
}

.content3 {
  width: 1400px;
  margin: 0 auto 168px;

  .l {
    width: 730px;
    height: 654px;
    background: url('@/assets/image/Slice 32@3x(1).png') no-repeat center/100% 100%;

    h1 {
      padding-top: 36px;
      text-align: center;
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 50px;
      color: #000000;
    }
  }

  .r {
    margin-left: 50px;

    h2 {
      margin-top: 36px;
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 80px;
      text-align: left;

      &:nth-of-type(1) {
        background: linear-gradient(0deg, #F4A3FF 0%, #BA6EFF 100%);
        -webkit-background-clip: text;
        /* 裁剪背景到文字形状 */
        -webkit-text-fill-color: transparent;
        /* 文字填充透明，显示背景 */
      }

      &:nth-of-type(2) {
        background: linear-gradient(0deg, #81EAFF 0%, #5175EB 100%);
        -webkit-background-clip: text;
        /* 裁剪背景到文字形状 */
        -webkit-text-fill-color: transparent;
        /* 文字填充透明，显示背景 */
      }

      &:nth-of-type(3) {
        background: linear-gradient(0deg, #6DEAD3 0%, #1DC9C3 100%);
        -webkit-background-clip: text;
        /* 裁剪背景到文字形状 */
        -webkit-text-fill-color: transparent;
        /* 文字填充透明，显示背景 */
      }
    }

    p {
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 18px;
      color: #8C898E;
      text-align: left;
    }
  }
}

.content4 {
  /* height: 921px; */
  min-height: 921px;
  background: url('@/assets/image/Slice 32@3x.png') no-repeat center/100% 100%;
  padding: 52px 280px 50px;
  position: relative;

  h1 {
    margin-left: 53px;
    margin-right: 42px;
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 50px;
    color: #000000;
  }


  .box1 {
    margin: 75px 35px 0 0;
  }

  .card {
    width: 352px;
    padding: 38px 35px;
    border-radius: 8px 8px 8px 8px;
    margin-bottom: 34px;

    .title {
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 20px;
      color: #000000;
      text-indent: 20px;
      text-align: left;
      position: relative;
      height: 30px;
      line-height: 30px;
      margin-bottom: 17px;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 30px;
        width: 3px;
        background-color: #68A9C7;
      }
    }

    li {
      font-family: Inter, Inter;
      font-weight: 500;
      font-size: 15px;
      color: #8C898E;
      line-height: 20px;
      text-align: left;
      display: flex;
      .dot{
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #97949A;
        margin-top: 8px;
        margin-right: 4px;
      }
      .txt{
        flex: 1;
      }
    }

    &:nth-of-type(1) {
      background: linear-gradient(146deg, #D6EFFF 0%, rgba(172, 204, 255, 0) 94%);
    }

    &:nth-of-type(2) {
      background: linear-gradient(146deg, #EAD6FF 0%, rgba(240, 172, 255, 0) 94%);

      .title::before {
        background-color: #CD8EDF;
      }
    }

    &:nth-of-type(3) {
      background: linear-gradient(146deg, #FFD6D7 0%, rgba(255, 172, 172, 0) 94%);

      .title::before {
        background-color: #EA8A9B;
      }
    }

  }

  .box2 {
    .card {
      &:nth-of-type(1) {
        background: linear-gradient(146deg, #FFEDD6 0%, rgba(255, 208, 172, 0) 94%);

        .title::before {
          background-color: #E9AF98;
        }
      }

      &:nth-of-type(2) {
        background: linear-gradient(146deg, #E5FFD6 0%, rgba(234, 255, 172, 0) 94%);

        .title::before {
          background-color: #C0E49E;
        }
      }

      &:nth-of-type(3) {
        background: linear-gradient(146deg, #FFFAD6 0%, rgba(255, 251, 202, 0) 100%);

        .title::before {
          background-color: #F8EE41;
        }
      }
    }
  }

}

.content5 {
  width: 1343px;
  margin: 0 auto;

  h1 {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 50px;
    color: #000000;
    margin: 15px 0 35px 53px;
  }

  .inner {
    background: url('@/assets/image/Slice 27@3x.png') no-repeat center/100% 100%;
    width: 1281px;
    height: 273px;
    padding: 47px 31px 0;
  }

  .connect {
    width: 159px;
    height: 42px;
    border-radius: 60px 60px 60px 60px;
    border: 1px solid #FFFFFF;
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
  }

  h2 {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    margin: 20px 0 40px;
  }

  p {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 18px;
    color: #D3D3D3;
    width: 50%;
  }
}

.content6 {
  width: 1343px;
  margin: 35px auto 161px;

  .inner {
    width: 424px;
    height: 320px;
    position: relative;
    background: url('@/assets/image/Slice 27@3x(1).png') no-repeat center/100% 100%;

    .txt1 {
      width: 104px;
      height: 39px;
      line-height: 39px;
      border-radius: 60px 60px 60px 60px;
      border: 1px solid #FFFFFF;
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 14px;
      color: #FFFFFF;
      text-align: center;
      position: absolute;
      top: 96px;
      left: 31px;
    }

    .txt2 {
      font-family: Inter, Inter;
      font-weight: bold;
      font-size: 30px;
      color: #FFFFFF;
      position: absolute;
      top: 154px;
      left: 31px;
    }

    .txt3 {
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 18px;
      color: #fff;
      position: absolute;
      top: 219px;
      left: 31px;
      width: 303px;
      text-align: left;
      line-height: 26px;
    }

    &:nth-of-type(2) {
      background: url('@/assets/image/Slice 27@3x(2).png') no-repeat center/100% 100%;
    }

    &:nth-of-type(3) {
      background: url('@/assets/image/Slice 27@3x(3).png') no-repeat center/100% 100%;
    }
  }
}



footer {
  padding: 85px 0 52px;

  .txt {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 23px;
    letter-spacing: 4px;
  }
  .brand{
    width: 1039px;
    height:76px;
    background: url('@/assets/image/footer.png') no-repeat center/100% 100%;
    margin: 26px 0 49px;
  }

  .brand img {
    width: 156px;
    height: 78px;
    margin: 10px 0 63px;
  }

  .logo1 {
    width: 186px;
    height: 59px;
  }

  .connect {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 16px;
    color: #3E3E59;
    line-height: 26px;
    text-align: center;
    text-decoration: underline;
    margin-top: 42px;
    cursor: pointer;
  }
}
.bot-txt{
  line-height: 30px;
  margin-top: 20px;
}
</style>